import { useContext } from "react";
import AuthContext from "../AuthContext";
import { AuthAPI } from "../types";

export default function useAuth(): AuthAPI {
  return useContext(AuthContext);
}
